import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file 数据请求工具-ajax
 * @author alfielv
 */
import axios from 'axios'; // 默认初始化axios实例

var defaultAxiosInstance = axios.create();
export var Ajax = /*#__PURE__*/function () {
  function Ajax(requestInstance) {
    _classCallCheck(this, Ajax);

    _defineProperty(this, "axiosInstance", void 0);

    this.axiosInstance = requestInstance || defaultAxiosInstance;
  }

  _createClass(Ajax, [{
    key: "request",
    value: function request(url, options) {
      return this.axiosInstance(_objectSpread({
        url: url
      }, options)).then(function (response) {
        // http状态码校验
        var status = response.status,
            statusText = response.statusText,
            _response$data = response.data,
            responseData = _response$data === void 0 ? {} : _response$data;

        if (status > 400 || status < 200) {
          var error = new Error("API ".concat(url, " http status is ").concat(status, " ").concat(statusText));
          return Promise.reject(error);
        } // 业务级接口code校验，暂时兼容两种规范


        var data = responseData.data,
            code = responseData.code,
            message = responseData.message;

        if (code && code !== 0) {
          var _error = new Error(message);

          return Promise.reject(_error);
        }

        return data;
      }).catch(function (error) {
        throw error;
      });
    }
  }, {
    key: "get",
    value: function get(url, data, options) {
      return this.request(url, _objectSpread({
        method: 'get',
        params: data
      }, options));
    }
  }, {
    key: "post",
    value: function post(url, data, options) {
      return this.request(url, _objectSpread({
        method: 'post',
        data: data
      }, options));
    }
  }, {
    key: "put",
    value: function put(url, data, options) {
      return this.request(url, _objectSpread({
        method: 'put',
        data: data
      }, options));
    }
  }]);

  return Ajax;
}();
;
export default new Ajax();